module.exports = __webpack_public_path__ + "img/random.9fbcc955.jpg";